import {
  UPDATE_AUTH_USER,
  UPDATE_USER_EMAIL,
  UPDATE_USER_PRODUCTS,
  UPDATE_USER_ROLE,
} from '../actions/constants'

const initialState = {
  authUser: false,
  userEmail: null,
  userRole: null,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case UPDATE_AUTH_USER:
      return {
        ...state,
        authUser: action.payload,
      }
    case UPDATE_USER_EMAIL:
      return {
        ...state,
        userEmail: action.payload,
      }
    case UPDATE_USER_PRODUCTS:
      return {
        ...state,
        productList: action.payload,
      }
    case UPDATE_USER_ROLE:
      return {
        ...state,
        userRole: action.payload,
      }
    default:
      return {
        ...state,
      }
  }
}
